import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import React from "react";
export function PasswordField(props) {
    const [show, setShow] = React.useState(false);
    return (React.createElement(TextField, Object.assign({}, props, { type: show ? "text" : "password", InputProps: {
            ...props.InputProps,
            endAdornment: (React.createElement(InputAdornment, { position: "end" },
                React.createElement(IconButton, { "aria-label": "Toggle password visibility", onClick: () => setShow(!show) }, show ? React.createElement(VisibilityOff, null) : React.createElement(Visibility, null)))),
        } })));
}
;
//# sourceMappingURL=index.js.map